import { render, staticRenderFns } from "./drawer-icon.vue?vue&type=template&id=7c8c4b64&"
import script from "./drawer-icon.vue?vue&type=script&lang=js&"
export * from "./drawer-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports